import { Transition } from "components/shared/column";
import Loader from "components/shared/loader";
import { noRolesOtherThan } from "helpers/roles";
import React, { useEffect, useState } from "react";
import ProfileBody from "./body";
import ProfileHead from "./head";

export default function Profile(props) {
    const [isLoading, setIsLoadind] = useState(true);

    const updateProfile = () => {
        const { getUser, getOrg, getNotificationOptions, roles } = props;
        const req = [getUser(), getNotificationOptions()];
        if (!noRolesOtherThan(roles, ["isTechSupport", "isAccountManager", "isDiagnostics", "isIntegrationManager"])) {
            req.push(getOrg());
        }
        return Promise.all(req).then(() => setIsLoadind(false));
    };

    useEffect(() => {
        updateProfile();
    }, []);

    const isAdmin = () => {
        const { isTruckingOrganizationAdmin, isCargoOwnerAdmin } = props.roles;
        return isTruckingOrganizationAdmin || isCargoOwnerAdmin;
    };

    const isManager = () => {
        const { isTruckingOrganizationManager, isCargoOwnerManager } = props.roles;
        return isTruckingOrganizationManager || isCargoOwnerManager;
    };

    return (
        <div className="page-content">
            <Transition dir="full">
                {isLoading ? (
                    <Loader prefix="absolute-center" />
                ) : (
                    <div className="profile">
                        <div className="overflow-auto h-100">
                            <ProfileHead {...props} isAdmin={isAdmin()} isManager={isManager()} />
                            <ProfileBody {...props} isAdmin={isAdmin()} isManager={isManager()} />
                        </div>
                    </div>
                )}
            </Transition>
        </div>
    );
}
